export default __webpack_public_path__ + "static/media/global-icon-three-hover.61590b21.svg";